window.okeReviewsWidgetOnInit = function () {
    setUpReview();
    setUpHeader();
    var observer = new MutationObserver(function () {
        setUpReview();
    });

    var reviewMainElement = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMainElement) {
        observer.observe(reviewMainElement, {
            childList: true
        });
    }
}

window.okeReviewsQandaOnInit = function () {
    setUpQandA();
}

// Move star and date into reivew side and move recommended into review primary
function setUpReview() {
    var reviews = document.querySelectorAll('.okeReviews-reviews-review');

    reviews.forEach(function (element) {
        var reviewPrimary = element.querySelector('.okeReviews-review-primary');
        var reviewSide = element.querySelector('.okeReviews-review-reviewer-profile-details');
        var stars = reviewPrimary.querySelector('.okeReviews-starRating');
        var date = reviewPrimary.querySelector('.okeReviews-review-date');
        var recommend = element.querySelector('.okeReviews-review-recommendation');
        if (stars) {
            reviewSide.prepend(stars);
            stars.style.display = "inline-block";
        }
        if (date) {
            reviewSide.append(date);
            date.style.display = "block";
        }
        if (recommend) {
            recommend.style.display = "block";
            reviewPrimary.append(recommend);
        }
        var verified = element.querySelector('.okeReviews-review-reviewer-profile-status');
        var inner = element.querySelector('.okeReviews-review-reviewer-profile-details-inner');
        if (verified) {
            inner.append(verified);
        }
    });
}

// Move review button into control and reviews aggegrate into header
function setUpHeader() {
    var writeAReviewButton = document.querySelector('.js-okeReviews-writeReview');
    if(writeAReviewButton) {
      writeAReviewButton.innerText = "Leave a review";
      var footerWriteaAReview = writeAReviewButton.cloneNode(true);
      var reviewFooter = document.querySelector('.okeReviews-reviews-footer.js-okeReviews-footer');
      if (reviewFooter && footerWriteaAReview) {
          reviewFooter.prepend(footerWriteaAReview);
      }

      var starRating = document.querySelector('.okeReviews-star-snippet-wrapper');
      if (starRating) {
        var starSummary = starRating.querySelector(".okeReviews.okeReviews--theme");
        if (starSummary) {
            starSummary.append(writeAReviewButton);
        }
      }
    }

    var reviewsCount = document.querySelector('.okeReviews-reviews-controls-reviewCount');
    var aggregateRating = document.querySelector('.okeReviews-reviewsAggregate-summary-rating');
    if (reviewsCount && aggregateRating) {
        aggregateRating.append(reviewsCount);
    }

    var reviewsHeader = document.querySelector('.okeReviews-reviewsWidget-header');
    if (reviewsHeader && aggregateRating) {
        reviewsHeader.prepend(aggregateRating);
    }

}

// Move Ask A Question button to the footer
function setUpQandA() {
    var questionButtonOG = document.querySelector(".okeReviews-qandaWidget-header-controls-askQuestion.js-okeReviews-askQuestion.okeReviews-button");
    var qandaFooter = document.querySelector(".okeReviews-qandaWidget-footer.js-okeReviews-footer");
    if (qandaFooter && questionButton) {
        var questionButton = questionButtonOG.cloneNode(true);
        qandaFooter.prepend(questionButton);
        //       	questionButtonOG.style.display = "none";
    }
}
